import {
  TEAMS,
  TEAM,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  UPDATED,
  CLEAR_ITEMS,
  RESET_FILTER,
} from './mutation-types';

export default {
  [TEAMS](state, payload) {
    if (state.items.length > 0) {
      const items = [...state.items];
      if (!!state.sort.filter) {
        items = items.filter((item) => item.team_name.indexOf(state.sort.filter) !== -1);
      }
      const itemsIds = items.map(item => item.id);
      payload.forEach((item) => {
        const index = itemsIds.indexOf(item.id);
        if (index > -1) {
          items[index] = item;
        } else {
          items.push(item);
        }
      });
      state.items = items;
    } else {
      state.items = payload;
    }
    if (state.items.length > state.overallCount) {
      state.overallCount = state.items.length;
    }
  },
  [TEAM](state, payload) {
    state.items = state.items.map(item => (item.id === payload.id ? Object.assign({}, item, payload) : item));
  },
  [DELETE](state, payload) {
    if (Array.isArray(payload)) {
      state.items = state.items.filter(item => payload.indexOf(item.id) === -1);
    } else {
      state.items = state.items.filter(item => item.id !== payload);
    }
  },
  [SORT](state, payload) {
    state.sort = payload;
  },
  [MORE](state, payload) {
    state.more = payload;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
  [TOTAL](state, payload) {
    state.total = payload;
  },
  [UPDATED](state) {
    state.updated = Math.floor(Date.now() / 1000);
  },
  [CLEAR_ITEMS](state) {
    state.items = [];
    state.total = 0;
    state.more = true;
  },
  [RESET_FILTER](state) {
    state.sort.filter = '';
  },
};
